<li class="flex items-center gap-2">
  <div>
    @if (status() === 'idle' || status() === 'invalid') {
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="0.5"
          y="0.5"
          width="13"
          height="13"
          rx="6.5"
          [ngClass]="status() === 'idle' ? 'fill-gray-30' : 'fill-secondary'"
        />
        <path d="M5 9L9 5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9 9L5 5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    } @else if (status() === 'valid') {
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 0.5C5.71442 0.5 4.45772 0.881218 3.3888 1.59545C2.31988 2.30968 1.48676 3.32484 0.994786 4.51256C0.502816 5.70028 0.374095 7.00721 0.624899 8.26809C0.875703 9.52896 1.49477 10.6872 2.40381 11.5962C3.31285 12.5052 4.47104 13.1243 5.73192 13.3751C6.99279 13.6259 8.29973 13.4972 9.48744 13.0052C10.6752 12.5132 11.6903 11.6801 12.4046 10.6112C13.1188 9.54229 13.5 8.28558 13.5 7C13.498 5.2767 12.8126 3.62456 11.594 2.40601C10.3754 1.18745 8.7233 0.501992 7 0.5ZM10.0957 5.86182L6.42871 9.36182C6.33548 9.45053 6.21171 9.5 6.08301 9.5C5.95432 9.5 5.83054 9.45053 5.73731 9.36182L3.9043 7.61182C3.80854 7.52008 3.7531 7.39409 3.75016 7.26151C3.74723 7.12894 3.79704 7.00062 3.88865 6.90474C3.98026 6.80886 4.10618 6.75326 4.23875 6.75015C4.37133 6.74705 4.49971 6.7967 4.59571 6.88818L6.08301 8.30859L9.4043 5.13818C9.5003 5.0467 9.62868 4.99705 9.76126 5.00015C9.89383 5.00326 10.0198 5.05886 10.1114 5.15474C10.203 5.25062 10.2528 5.37894 10.2498 5.51152C10.2469 5.64409 10.1915 5.77008 10.0957 5.86182Z"
          fill="#357C47"
        />
      </svg>
    }
  </div>
  <span class="text-body-03" [ngClass]="{ 'text-secondary': status() === 'invalid' }">
    <ng-content></ng-content>
  </span>
</li>
